import { Button, Flex, Form, Input } from 'antd'
import Checkbox from 'antd/es/checkbox/Checkbox'
import { useTheme } from 'antd-style'
import { useNavigate } from 'react-router-dom'

import { useLoginServiceLoginEndpoint } from 'src/api/queries'
import { ApiError } from 'src/api/requests'
import { ACCESS_TOKEN_KEY, requiredRules } from 'src/app-constants'
import { MpassIcon } from 'src/assets'
import { Text } from 'src/components'
import { useSessionContext } from 'src/contexts'
import { useLocales } from 'src/locales'
import { paths } from 'src/paths'
import { formErrorHandler } from 'src/utils'

import { AuthHeader } from '../components'
import { useStyles } from '../styles'

export const Login = () => {
  const { t } = useLocales()
  const { styles } = useStyles()
  const { onLogin } = useSessionContext()
  const [form] = Form.useForm()
  const navigate = useNavigate()

  const palette = useTheme()

  const { mutate, isPending } = useLoginServiceLoginEndpoint({
    onSuccess: (data) => {
      if (data.twoFactorLoginRequired) {
        localStorage.setItem(ACCESS_TOKEN_KEY, `"${data?.accessToken}"`)
        navigate(paths.auth.confirm)
      } else {
        onLogin(data)
      }
    },
    onError: (error: ApiError) => formErrorHandler(error.body.errors)
  })

  const onSubmit = async () => {
    const values = await form.validateFields()

    const requestBody = {
      email: values?.email,
      password: values?.password
    }

    mutate({ requestBody })
  }

  return (
    <Flex vertical gap={32}>
      <AuthHeader
        title={t('auth.login_title')}
        description={t('auth.login_subtitle')}
      />

      <Form layout="vertical" form={form}>
        <Flex vertical gap={16}>
          <Form.Item
            name="email"
            label={t('form.email')}
            rules={requiredRules?.concat({
              type: 'email',
              message: t('form.email_error')
            })}
            className={styles.formItem}
          >
            <Input size="large" placeholder={t('form.email_placeholder')} />
          </Form.Item>

          <Form.Item
            name="password"
            label={t('form.password')}
            rules={requiredRules}
            className={styles.formItem}
          >
            <Input.Password size="large" placeholder="••••••••" />
          </Form.Item>

          <Flex gap={8} justify="space-between" align="center">
            <Form.Item
              name="remember_me"
              label={null}
              valuePropName="checked"
              initialValue={false}
            >
              <Checkbox>{t('auth.remember_me')}</Checkbox>
            </Form.Item>

            <Button
              type="link"
              onClick={() => navigate(paths.auth.forgotPassword)}
            >
              <Text color={palette.orange}>{t('auth.reset_password')}</Text>
            </Button>
          </Flex>

          <Button
            type="primary"
            size="large"
            onClick={onSubmit}
            loading={isPending}
          >
            {t('auth.login_title')}
          </Button>

          <Button htmlType="submit" block size="large" icon={<MpassIcon />}>
            {t('auth.mpass_auth')}
          </Button>
        </Flex>
      </Form>
    </Flex>
  )
}
